import store from './config.js'
import * as namespaceStore from "./namespaceStore.js"
import { v4 as uuidv4 } from 'uuid';

export default class GeneralClassMethod {
    constructor() {}

    static nameFormater(name) {
        let formatedName = String(name).replaceAll('_', '');
        return formatedName.charAt(0).toLowerCase() + formatedName.slice(1);
    }

    valueByVariable(variable, variableArray) {
        const variableObject = variableArray.find(e => e.Value == variable);
        if (variableObject) {
            return variableObject.Id;
        }
        return variable;
    }

    valueOfRessource(ressource, arrayReturn) {
        let variable = store.getters[namespaceStore.THEME + "/ressourceByIDSoft"](ressource);
        if (variable) {
            const ressourceId = "@" + variable.idSoft + "@";
            if (arrayReturn.find(e => e.Id == ressourceId) == undefined) {
                arrayReturn.push({
                    Id: ressourceId,
                    SiteId: variable.id,
                });
            }
        }
        return arrayReturn;
    }
    toExportObject(variableArray = [], ressourceArray = []) {
        return {};
    }

    valueOfVariable(variable, arrayReturn, nameElement, propertyName) {
        const variableObject = arrayReturn.find(e => e.Value == variable);
        if (variableObject == undefined) {
            arrayReturn.push({
                Id: "@" + uuidv4() + "@",
                Value: variable,
                Description: nameElement + "[" + propertyName + "]",
            });
        } else {
            variableObject.Description += ", " + nameElement + "[" + propertyName + "]";
        }
        return arrayReturn;
    }
    getVariables(arrayReturn = [], pageName = "", nameElement = "") {
        if (this.constructor.variableOfInstance == undefined) return arrayReturn;
        nameElement = this.ExportNamedElement ? this.ExportNamedElement : nameElement;
        if (pageName == "") {
            pageName = this.Name;
        }
        this.constructor.variableOfInstance().forEach(el => {
            if (el.property == "CompositionElement") return;//ignore composition elements
            if (el.jsType == "Array" && this[el.property] && this[el.property].length) {
                this[el.property].forEach(e => {
                    if (typeof e === 'object' && !Array.isArray(e) && e !== null) {
                        arrayReturn = e.getVariables(arrayReturn, pageName, nameElement)
                    }
                    else if (e && el.isVariable == true) {
                        arrayReturn = this.valueOfVariable(e, arrayReturn, pageName, nameElement);
                    }
                });
            }
            else if (el.jsType == "Class" && this[el.property]) {
                arrayReturn = this[el.property].getVariables(arrayReturn, pageName, nameElement);
            }
            else if (this[el.property] && el.isVariable == true) {
                arrayReturn = this.valueOfVariable(this[el.property], arrayReturn, pageName, nameElement);
            }
        });
        return arrayReturn;
    }

    getRessources(arrayReturn = []) {
        if (this.constructor.variableOfInstance == undefined) return arrayReturn;
        this.constructor.variableOfInstance().forEach(el => {
            if (el.property == "CompositionElement") return;//ignore composition elements
            if (el.jsType == "Array" && this[el.property] && this[el.property].length) {
                this[el.property].forEach(e => {
                    if (typeof e === 'object' && !Array.isArray(e) && e !== null) {
                        arrayReturn = e.getRessources(arrayReturn)
                    }
                    else if (e && el.isRessource == true) {
                        arrayReturn = this.valueOfRessource(e, arrayReturn);
                    }
                });
            }
            else if (el.jsType == "Class" && this[el.property]) {
                arrayReturn = this[el.property].getRessources(arrayReturn);
            }
            else if (this[el.property] && el.isRessource == true) {
                arrayReturn = this.valueOfRessource(this[el.property], arrayReturn);
            }
        });
        return arrayReturn;
    }

    dispose() {
        if (this.constructor.variableOfInstance == undefined) return;
        this.constructor.variableOfInstance().forEach(el => {
            if (el.jsType == "Array") {
                this[el.property].forEach(e => {
                    if (typeof e === 'object' && !Array.isArray(e) && e !== null && e.dispose) {
                        e.dispose();
                    }
                });
                this[el.property] = [];
            }
            else if (el.jsType == "Class") {
                this[el.property].dispose();
                this[el.property] = null;
            }
        });
    }
}